import { Hint } from '@systemeio/ui'
import React, { useEffect } from 'react'
import { useSubstitutes } from 'shared/components/dashboard-mail-editor/hooks/use-substitutes'
import { DisclosureBox } from 'shared/components/disclosure-box'
import TransLoco from 'shared/components/trans-loco'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { twJoin } from 'tailwind-merge'
import { DashboardMailEditorCommonProps } from '../types/common'

export interface SubstituteInterface {
  slug: string
  name: string
}

export interface SubstitutesBlockProps extends Pick<DashboardMailEditorCommonProps, 'inModal'> {
  additionalSubstitutes?: SubstituteInterface[]
}

const SubstitutesBlock = ({ inModal, additionalSubstitutes }: SubstitutesBlockProps) => {
  const { t } = useLocoTranslation()
  const [buttonAs, setButtonAs] = React.useState<'div' | 'button'>('div')

  const { substitutionData, isReady } = useSubstitutes(additionalSubstitutes)

  useEffect(() => {
    // fixing hydration error
    setButtonAs('button')
  }, [])

  return (
    <DisclosureBox
      buttonAs={buttonAs}
      buttonClassName={'cursor-pointer'}
      wrapperClassName={twJoin(inModal && 'border border-text-secondary/30 rounded-lg')}
      title={
        <Hint label={t('dashboard.email.available_substitutes.tooltip')}>
          <b className={`text-text-primary text-start text-[17px]`}>
            {t('dashboard.email.available_substitutes.title')}
          </b>
        </Hint>
      }
    >
      {isReady ? (
        <ul className={'flex flex-col gap-3'}>
          {substitutionData.map(el => (
            <li key={el.id} className={'flex flex-wrap gap-1'}>
              <span className={'text-danger whitespace-nowrap'}>{el.id}</span>-
              {el.customCaption ?? <span>{el.caption}</span>}
            </li>
          ))}
        </ul>
      ) : (
        <EmailSubstitutesSkeleton />
      )}
    </DisclosureBox>
  )
}

const EmailSubstitutesSkeleton = () => (
  <div className={'flex animate-pulse flex-col gap-3'}>
    <div className="bg-skeleton-primary rounded-sm text-transparent">.</div>
    <div className="bg-skeleton-primary rounded-sm text-transparent">.</div>
    <div className="bg-skeleton-primary rounded-sm text-transparent">.</div>
    <div className="bg-skeleton-primary rounded-sm text-transparent">.</div>
    <div className="bg-skeleton-primary rounded-sm text-transparent">.</div>
    <div className="bg-skeleton-primary rounded-sm text-transparent">.</div>
    <div className="bg-skeleton-primary rounded-sm text-transparent">.</div>
    <div className="bg-skeleton-primary rounded-sm text-transparent">.</div>
    <div className="bg-skeleton-primary rounded-sm text-transparent">.</div>
    <div className="bg-skeleton-primary rounded-sm text-transparent">.</div>
    <div className="bg-skeleton-primary rounded-sm text-transparent">.</div>
    <div className="bg-skeleton-primary rounded-sm text-transparent">.</div>
    <div className="bg-skeleton-primary rounded-sm text-transparent">.</div>
  </div>
)

export default SubstitutesBlock
